// useStartSession.js
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { env } from "../environment";
import { postStartSession } from "../store/apiActions";
import { encrypted } from "../utils/Utility";
import { clearLocalStoragePreservingTheme } from "../utils/Utility";

const useStartSession = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const startSession = async () => {
    try {
      const loggedInDetails = JSON.parse(encrypted.decrypt(localStorage.getItem("LoggedInDetails")));
      if (!loggedInDetails || !loggedInDetails.username) {
        toast.error("User details not found. Please log in again.");
        navigate("/login");
        return;
      }
      const requestBody = {
        id: loggedInDetails.id || null,
        full_name: loggedInDetails.full_name || "Unknown User",
        username: loggedInDetails.username,
        mobile_no: loggedInDetails.mobile_no || "",
        active: loggedInDetails.active ?? true,
        role: loggedInDetails.role || "USER",
      };
      const response = await dispatch(postStartSession(`${env.baseURL}/start-session`, requestBody));
      if (response) {
        encrypted.setEncryptedItem(
          "startSession", response);
      }
      return response;
    } catch (error) {
      console.error("Error starting session:", error);
      toast.error("Failed to start session.");
      clearLocalStoragePreservingTheme();
      navigate("/sign-in");
    }
  };
  return startSession;
};



export default useStartSession;